import { render } from "./SecurityProfileForm.vue?vue&type=template&id=e92f6d60&ts=true"
import script from "./SecurityProfileForm.vue?vue&type=script&lang=ts"
export * from "./SecurityProfileForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__